import React, { useState } from 'react';
import './Header.css';
import siteContent from '../../data/siteContent';

const Header = () => {
  const { brand, hero } = siteContent;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="site-header">
        <nav className="navbar">
          <a className="navbar__brand" href="#top" onClick={closeMenu}>
            <img className="navbar__logo" src={brand.logo} alt="KINI Consulting Group logo" />
            <span className="navbar__brand-name">{brand.name}</span>
          </a>

          <div className="navbar__desktop-menu">
            <a href="#services">Services</a>
            <a href="#about">About</a>
            <a href="#testimonials">Testimonials</a>
            <a href="#contact">Contact</a>
          </div>

          <a className="navbar__cta navbar__cta--desktop" href="#contact">
  Contact Us
</a>

          <button
            className="navbar__toggle"
            type="button"
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span />
            <span />
            <span />
          </button>
        </nav>

        <div className={`mobile-menu ${isMenuOpen ? 'mobile-menu--open' : ''}`}>
          <a href="#services" onClick={closeMenu}>Services</a>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#testimonials" onClick={closeMenu}>Testimonials</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
          <a className="mobile-menu__cta" href="#contact" onClick={closeMenu}>
  Contact Us
</a>
        </div>
      </header>

      <section className="hero-section" id="top">
        <div className="hero">
          <div className="hero__image-wrap">
            <img className="hero__image" src={hero.image} alt="KINI Consulting Group founder" />
          </div>

          <div className="hero__content">
            <h1 className="hero__title">{hero.title}</h1>
            <p className="hero__text">{hero.description}</p>

            <div className="hero__actions">
              <a className="hero__button hero__button--primary" href={hero.primaryButton.href}>
                {hero.primaryButton.label}
              </a>
              <a className="hero__button hero__button--secondary" href={hero.secondaryButton.href}>
                {hero.secondaryButton.label}
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;